import fromEntriesToObject from 'utils/converters/object/fromEntriesToObject.util';
import fromObjectToEntries from 'utils/converters/object/fromObjectToEntries.util';
import alwaysSame from 'utils/functions/nullary/alwaysSame.util';
import isFn from 'utils/predicates/function/isFn.util';

const transformObject = (transformer, object) => {
  const fn = isFn(transformer) ? transformer : alwaysSame;
  return fromEntriesToObject(fn(fromObjectToEntries(object)));
};

export default transformObject;
